var _defs, _clipPath, _rect, _rect2, _path, _path2, _g, _g2, _path3, _rect3, _path4, _g3, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g5, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "4000px",
    height: "2500px",
    viewBox: "0 0 4000 2500",
    enableBackground: "new 0 0 4000 2500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M3278.7,2525.1c747.9-1512,4.9-1909.5-548.1-1823.1C2271.3,773.8,1839,37.6,1224,64.9 C608.9,92.3,280.9,648.1,444.9,1149.2c164,501.2-665.2,692.5-264.2,1375.9H3278.7z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 3439.8784,
    y1: -131.6902,
    x2: 742.6052,
    y2: 1985.4171
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004132,
    style: {
      stopColor: "#D0E4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEE8FA"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -503.2,
    y: -471.4,
    clipPath: "url(#SVGID_2_)",
    fill: "url(#SVGID_3_)",
    width: 4881.8,
    height: 3037.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 3945.0603,
    y1: 1452.4774,
    x2: 172.3858,
    y2: 3271.2744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2D6FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8D73FD"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -503.2,
    y: 2274.3,
    clipPath: "url(#SVGID_2_)",
    fill: "url(#SVGID_4_)",
    width: 4881.8,
    height: 291.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M1449,2369.4c0,0,6.8-0.7,19.6-2.1c6.4-0.7,14.3-1.4,23.5-2.3c9.3-0.9,19.9-1.8,31.8-2.9 c23.8-2.1,52.8-4.3,86-6.7c16.6-1.1,34.3-2.3,52.9-3.5c18.6-1.1,38.2-2.2,58.6-3.4c20.4-1,41.7-2.1,63.7-3.2 c22-0.9,44.8-1.9,68.2-2.9c23.4-0.8,47.4-1.7,72-2.6c24.6-0.7,49.7-1.4,75.2-2.1c51.1-1.3,103.8-2.2,157.4-2.9 c53.6-0.6,108.1-0.8,162.6-0.8c54.5,0.1,108.9,0.5,162.6,1.2c53.6,0.7,106.4,1.7,157.4,3.2c12.8,0.3,25.4,0.7,38,1 c12.5,0.4,25,0.8,37.2,1.2c24.6,0.8,48.6,1.6,72,2.6c46.8,1.8,91.1,3.9,131.9,6.1c40.8,2.2,78.3,4.5,111.5,6.7 c16.6,1.2,32.1,2.2,46.5,3.3c14.4,1.1,27.6,2.1,39.5,3.1c6,0.5,11.6,1,16.9,1.4c5.3,0.5,10.3,0.9,14.9,1.3 c9.3,0.9,17.1,1.6,23.5,2.2c12.8,1.3,19.6,2,19.6,2c9,0.9,15.6,9,14.7,18c-0.8,7.9-7.1,13.9-14.7,14.7c0,0-6.8,0.7-19.6,2 c-6.4,0.6-14.3,1.3-23.5,2.2c-4.6,0.4-9.6,0.9-14.9,1.3c-5.3,0.4-10.9,0.9-16.9,1.4c-11.9,1-25.1,2-39.5,3.1 c-14.4,1.1-29.9,2.2-46.5,3.3c-33.2,2.3-70.6,4.5-111.5,6.7c-40.8,2.2-85.1,4.3-131.9,6.1c-23.4,1-47.4,1.8-72,2.6 c-12.3,0.4-24.7,0.8-37.2,1.2c-12.5,0.3-25.2,0.7-38,1c-51.1,1.5-103.8,2.4-157.4,3.2c-53.6,0.7-108.1,1.2-162.6,1.2 c-54.5,0.1-108.9-0.1-162.6-0.7c-53.6-0.6-106.4-1.5-157.4-2.9c-25.5-0.7-50.6-1.4-75.2-2.1c-24.6-0.9-48.6-1.7-72-2.6 c-23.4-1-46.2-2-68.2-2.9c-22-1.1-43.3-2.2-63.7-3.2c-20.4-1.2-40-2.3-58.6-3.4c-18.6-1.2-36.3-2.4-52.9-3.5 c-33.2-2.4-62.1-4.6-86-6.7c-11.9-1-22.6-2-31.8-2.9c-9.3-0.9-17.1-1.6-23.5-2.3c-12.8-1.4-19.6-2.1-19.6-2.1 c-9-1-15.5-9.1-14.6-18.1C1435.2,2376.1,1441.4,2370.2,1449,2369.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M725.4,2368.8c0,0,2.4-0.6,6.9-1.7c2.2-0.5,5-1.2,8.3-1.9c3.3-0.7,7-1.5,11.2-2.3 c8.4-1.7,18.5-3.5,30.2-5.4c5.8-0.9,12-1.8,18.6-2.8c6.5-0.9,13.4-1.8,20.6-2.8c7.2-0.8,14.7-1.7,22.4-2.6c7.7-0.8,15.7-1.6,24-2.4 c8.2-0.7,16.7-1.4,25.3-2.1c8.6-0.6,17.5-1.1,26.4-1.7c17.9-1.1,36.5-1.8,55.3-2.3c18.8-0.5,38-0.7,57.1-0.6 c19.1,0,38.3,0.4,57.1,1c18.8,0.6,37.4,1.4,55.3,2.6c4.5,0.3,8.9,0.5,13.3,0.8c4.4,0.3,8.8,0.7,13.1,1c8.6,0.7,17.1,1.3,25.3,2.1 c16.4,1.5,32,3.2,46.4,4.9c14.4,1.8,27.5,3.6,39.2,5.5c5.8,0.9,11.3,1.8,16.3,2.7c5,0.9,9.7,1.7,13.9,2.5c2.1,0.4,4.1,0.8,5.9,1.1 c1.9,0.4,3.6,0.7,5.2,1.1c3.3,0.7,6,1.3,8.3,1.8c4.5,1.1,6.9,1.6,6.9,1.6c3.2,0.7,5.5,7.3,5.2,14.6c-0.3,6.4-2.5,11.3-5.2,11.9 c0,0-2.4,0.6-6.9,1.6c-2.2,0.5-5,1.1-8.3,1.8c-1.6,0.3-3.4,0.7-5.2,1.1c-1.9,0.4-3.8,0.7-5.9,1.1c-4.2,0.8-8.8,1.6-13.9,2.5 c-5,0.9-10.5,1.8-16.3,2.7c-11.7,1.8-24.8,3.7-39.2,5.5c-14.4,1.8-29.9,3.5-46.4,4.9c-8.2,0.8-16.7,1.4-25.3,2.1 c-4.3,0.3-8.7,0.7-13.1,1c-4.4,0.3-8.9,0.5-13.3,0.8c-17.9,1.2-36.5,2-55.3,2.6c-18.8,0.6-38,0.9-57.1,1 c-19.1,0.1-38.3-0.1-57.1-0.6c-18.8-0.5-37.4-1.3-55.3-2.3c-9-0.6-17.8-1.2-26.4-1.7c-8.6-0.7-17.1-1.4-25.3-2.1 c-8.2-0.8-16.2-1.6-24-2.4c-7.7-0.9-15.2-1.8-22.4-2.6c-7.2-1-14.1-1.9-20.6-2.8c-6.5-1-12.7-2-18.6-2.8 c-11.7-1.9-21.8-3.7-30.2-5.4c-4.2-0.8-7.9-1.6-11.2-2.3c-3.3-0.7-6-1.3-8.3-1.9c-4.5-1.1-6.9-1.7-6.9-1.7 c-3.2-0.8-5.5-7.4-5.1-14.7C720.6,2374.3,722.8,2369.4,725.4,2368.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF647B",
    d: "M3838.3,541.3c0,253.3-205.3,458.6-458.6,458.6c-253.3,0-458.6-205.3-458.6-458.6 c0-253.3,205.3-458.6,458.6-458.6C3633,82.7,3838.3,288,3838.3,541.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E4F7",
    d: "M3754.6,541.3c0,207.1-167.9,374.9-374.9,374.9c-207.1,0-374.9-167.9-374.9-374.9 s167.9-374.9,374.9-374.9C3586.8,166.4,3754.6,334.2,3754.6,541.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF647B",
    d: "M3670.9,541.3c0,160.9-130.4,291.3-291.2,291.3c-160.9,0-291.3-130.4-291.3-291.3 s130.4-291.2,291.3-291.2C3540.5,250.1,3670.9,380.5,3670.9,541.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E4F7",
    d: "M3587.3,541.3c0,114.6-92.9,207.6-207.6,207.6c-114.6,0-207.6-92.9-207.6-207.6s92.9-207.6,207.6-207.6 C3494.3,333.8,3587.3,426.7,3587.3,541.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF647B",
    d: "M3503.6,541.3c0,68.4-55.5,123.9-123.9,123.9c-68.4,0-123.9-55.5-123.9-123.9 c0-68.4,55.5-123.9,123.9-123.9C3448.1,417.4,3503.6,472.9,3503.6,541.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E4F7",
    d: "M3433.4,541.3c0,29.7-24.1,53.7-53.7,53.7c-29.7,0-53.7-24.1-53.7-53.7c0-29.7,24-53.7,53.7-53.7 C3409.4,487.6,3433.4,511.6,3433.4,541.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3E4463",
    points: "3868.3,819.5 3430,577.5 3439,560.6 3883.7,790.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DFE0E5",
    points: "3930.1,768 3879.4,798.7 3803.3,758 3840.9,733.8 3860.7,741.4 3865.3,743.2 3883,750  3887.6,751.7 3905.2,758.5 3909.9,760.3  "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3909.1,761.3c-0.1,0-0.1,0.1-0.1,0.1l-32.3,18.1c-0.5,0.3-1.1,0.1-1.4-0.4c-0.3-0.5-0.1-1.1,0.3-1.4 l29.7-19.2l4.6,1.8C3909.8,760.7,3909.5,761.1,3909.1,761.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3886.8,752.8c-0.1,0-0.1,0-0.1,0.1l-32.3,18.1c-0.5,0.3-1.1,0.1-1.4-0.4c-0.3-0.5-0.1-1.1,0.3-1.4 L3883,750l4.6,1.8C3887.5,752.2,3887.2,752.5,3886.8,752.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3865.3,743.2c-0.2,0.4-0.5,0.8-0.8,1c0,0-0.1,0.1-0.1,0.1l-32.3,18.1c-0.5,0.3-1.1,0.1-1.4-0.4 c-0.2-0.5-0.1-1.1,0.4-1.4l29.6-19.2L3865.3,743.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DFE0E5",
    points: "3875.3,870.5 3872.6,811.4 3796.5,770.7 3797.3,815.4 3814.6,827.6 3818.7,830.5 3834.1,841.4  3838.1,844.3 3853.6,855.2 3857.6,858  "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3858,856.8c0-0.1,0-0.1,0-0.2l-2.9-36.9c0-0.6-0.5-1-1.1-0.9c-0.6,0-1,0.5-1,1l0.5,35.3l4,2.9 C3857.9,857.7,3858,857.3,3858,856.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3838.5,843c0-0.1,0-0.1,0-0.2l-2.9-36.9c0-0.6-0.5-1-1.1-0.9c-0.6,0-1,0.5-1,1l0.5,35.3l4,2.9 C3838.4,843.9,3838.6,843.5,3838.5,843z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3818.7,830.5c0.2-0.4,0.4-0.8,0.4-1.3c0,0,0-0.1,0-0.1l-2.9-36.9c0-0.6-0.6-1-1.1-1 c-0.5,0.1-0.9,0.5-0.9,1.1l0.5,35.3L3818.7,830.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCF3F",
    points: "3431.4,620.1 3437.7,570.8 3475.2,538.2 3362.9,530.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3E4463",
    points: "3790.6,108.2 3370,379.9 3359.4,364 3772.4,80.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DFE0E5",
    points: "3774.5,29.5 3777.5,88.6 3705.6,136.4 3702.1,91.8 3718.1,78 3721.9,74.8 3736.2,62.4 3740,59.2  3754.3,46.8 3758.1,43.6  "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3758.6,44.8c0,0.1,0,0.1,0,0.2l0.7,37c0,0.6-0.4,1-1,1c-0.5,0-1-0.4-1.1-0.9l-2.9-35.2l3.8-3.2 C3758.3,43.9,3758.5,44.3,3758.6,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3740.5,60.4c0,0.1,0,0.1,0,0.2l0.7,37c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1.1-0.9l-2.9-35.2l3.7-3.2 C3740.3,59.5,3740.5,59.9,3740.5,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3721.9,74.8c0.3,0.3,0.5,0.8,0.5,1.2c0,0,0,0.1,0,0.1l0.7,37c0,0.6-0.5,1.1-1,1.1c-0.5,0-1-0.5-1-1 l-3-35.2L3721.9,74.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DFE0E5",
    points: "3838.8,126.2 3785.4,100.6 3713.6,148.4 3753.4,168.8 3772.3,159.4 3776.8,157.2 3793.7,148.7  3798.1,146.5 3815,138.1 3819.5,135.9  "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3818.6,134.9c-0.1,0-0.1,0-0.1-0.1l-33.9-14.9c-0.5-0.2-1.1,0-1.4,0.5c-0.3,0.5,0,1.1,0.5,1.3 l31.4,16.3l4.4-2.2C3819.3,135.5,3819,135.1,3818.6,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3797.2,145.6c-0.1,0-0.1,0-0.1-0.1l-33.9-14.9c-0.5-0.2-1.1,0-1.3,0.5c-0.2,0.5,0,1.1,0.5,1.3 l31.4,16.3l4.4-2.2C3797.9,146.1,3797.6,145.8,3797.2,145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M3776.8,157.2c-0.2-0.4-0.5-0.7-0.9-0.9c0,0-0.1,0-0.1-0.1l-33.9-14.9c-0.5-0.2-1.2,0-1.4,0.6 c-0.2,0.5,0,1.1,0.5,1.3l31.3,16.3L3776.8,157.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCF3F",
    points: "3408.2,398.8 3367.8,369.9 3356.7,321.4 3297.1,416.9  "
  })))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#634E96",
    d: "M2436.9,310.5c-5.2,0-10.3-2.4-13.6-6.9l-46-62.1c-4.6-6.2-16.8-12.4-24.5-12.4h-50.1 c-7.8,0-19.9,6.1-24.5,12.4l-46,62.1c-5.6,7.5-16.2,9.1-23.7,3.5c-7.5-5.6-9.1-16.2-3.5-23.7l46-62.1 c11-14.9,33.3-26.1,51.8-26.1h50.1c18.5,0,40.8,11.2,51.8,26.1l46,62.1c5.6,7.5,4,18.2-3.5,23.7 C2443.9,309.4,2440.4,310.5,2436.9,310.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2806.6184,
    y1: 285.3058,
    x2: 1849.9458,
    y2: 2381.8457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8AA7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E9BFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M3151.6,2275.4c0,65.3-53.4,118.7-118.7,118.7H1611.5c-65.3,0-118.7-53.4-118.7-118.7V418.4 c0-65.3,53.4-118.7,118.7-118.7h1421.4c65.3,0,118.7,53.4,118.7,118.7V2275.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1622.9,
    y: 418.2,
    fill: "#E2EDF2",
    width: 1398.6,
    height: 1857.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A3EFF",
    d: "M2023.8,275.6v118.7c0,37.3,30.5,67.8,67.8,67.8h457.6c37.3,0,67.8-30.5,67.8-67.8V275.6H2023.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CFD3F7",
    d: "M3579.4,1266.4v262.2c0,21.9-17.9,39.9-39.9,39.9h-430.8c-21.9,0-39.9-17.9-39.9-39.9v-262.2 c0-21.9,17.9-39.9,39.9-39.9h430.8C3561.5,1226.5,3579.4,1244.4,3579.4,1266.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF647B",
    d: "M3579.4,1266.4v48.8h-510.5v-48.8c0-21.9,17.9-39.9,39.9-39.9h430.8 C3561.5,1226.5,3579.4,1244.4,3579.4,1266.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3141.8,
    y: 1349.6,
    fill: "#E2EDF2",
    width: 92.2,
    height: 47.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3278,
    y: 1410.6,
    fill: "#E2EDF2",
    width: 92.2,
    height: 47.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3414.3,
    y: 1471.7,
    fill: "#E2EDF2",
    width: 92.2,
    height: 47.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3141.8,
    y: 1471.7,
    fill: "#E2EDF2",
    width: 92.2,
    height: 47.9
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#634E96",
    d: "M3463.6,1249.9c0,14.6-12,26.6-26.6,26.6h-5.3c-14.6,0-26.6-12-26.6-26.6v-62.4c0-14.6,12-26.6,26.6-26.6 h5.3c14.6,0,26.6,12,26.6,26.6V1249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634E96",
    d: "M3229.6,1249.9c0,14.6-12,26.6-26.6,26.6h-5.3c-14.6,0-26.6-12-26.6-26.6v-62.4c0-14.6,12-26.6,26.6-26.6 h5.3c14.6,0,26.6,12,26.6,26.6V1249.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2724.2,597.3c0,15.4-15.3,28-33.9,28h-736.1c-18.7,0-33.9-12.6-33.9-28c0-15.4,15.3-28,33.9-28h736.1 C2708.9,569.4,2724.2,582,2724.2,597.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1678.7,
    y: 776.6,
    fill: "#CFD3F7",
    width: 1287,
    height: 110.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.6,
    y: 803.6,
    fill: "#FFFFFF",
    width: 56.7,
    height: 56.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2891.1,845.5h-834.5c-7.5,0-13.6-6.1-13.6-13.6c0-7.5,6.1-13.6,13.6-13.6h834.5 c7.5,0,13.6,6.1,13.6,13.6C2904.7,839.5,2898.6,845.5,2891.1,845.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1884.7,1368.6c0,9.3-7.6,17-17,17h-74.8c-9.3,0-17-7.6-17-17v-74.8c0-9.3,7.6-17,17-17h74.8 c9.3,0,17,7.6,17,17V1368.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,1314.2h-680.8c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2h680.8 c5.6,0,10.2,4.6,10.2,10.2C2878.6,1309.7,2874.1,1314.2,2868.5,1314.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,1368.6h-782.5c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2h782.5 c5.6,0,10.2,4.6,10.2,10.2C2878.6,1364,2874.1,1368.6,2868.5,1368.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1884.7,1613.4c0,9.3-7.6,17-17,17h-74.8c-9.3,0-17-7.6-17-17v-74.8c0-9.3,7.6-17,17-17h74.8 c9.3,0,17,7.6,17,17V1613.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,1559h-680.8c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2h680.8 c5.6,0,10.2,4.6,10.2,10.2C2878.6,1554.5,2874.1,1559,2868.5,1559z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,1613.4h-782.5c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2h782.5 c5.6,0,10.2,4.6,10.2,10.2C2878.6,1608.8,2874.1,1613.4,2868.5,1613.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1884.7,1858.2c0,9.3-7.6,17-17,17h-74.8c-9.3,0-17-7.6-17-17v-74.8c0-9.3,7.6-17,17-17h74.8 c9.3,0,17,7.6,17,17V1858.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,1803.8h-680.8c-5.6,0-10.2-4.6-10.2-10.2s4.6-10.2,10.2-10.2h680.8c5.6,0,10.2,4.6,10.2,10.2 S2874.1,1803.8,2868.5,1803.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,1858.2h-782.5c-5.6,0-10.2-4.6-10.2-10.2s4.6-10.2,10.2-10.2h782.5c5.6,0,10.2,4.6,10.2,10.2 S2874.1,1858.2,2868.5,1858.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1884.7,2103c0,9.3-7.6,17-17,17h-74.8c-9.3,0-17-7.6-17-17v-74.8c0-9.3,7.6-17,17-17h74.8 c9.3,0,17,7.6,17,17V2103z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,2048.6h-680.8c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2h680.8 c5.6,0,10.2,4.6,10.2,10.2C2878.6,2044,2874.1,2048.6,2868.5,2048.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,2103h-782.5c-5.6,0-10.2-4.6-10.2-10.2s4.6-10.2,10.2-10.2h782.5c5.6,0,10.2,4.6,10.2,10.2 S2874.1,2103,2868.5,2103z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M1884.7,1123.8c0,9.3-7.6,17-17,17h-74.8c-9.3,0-17-7.6-17-17V1049c0-9.3,7.6-17,17-17h74.8 c9.3,0,17,7.6,17,17V1123.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,1069.4h-680.8c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2h680.8 c5.6,0,10.2,4.6,10.2,10.2C2878.6,1064.9,2874.1,1069.4,2868.5,1069.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M2868.5,1123.8h-782.5c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2h782.5 c5.6,0,10.2,4.6,10.2,10.2C2878.6,1119.2,2874.1,1123.8,2868.5,1123.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M1833.3,1109.8c-0.3,0-0.5,0-0.8,0c-7.2-0.2-14-3.3-18.9-8.6l-16.7-18.1c-3.8-4.1-3.6-10.6,0.6-14.4 c4.1-3.8,10.6-3.5,14.4,0.6l16.7,18.1c1.2,1.3,2.8,2,4.5,2.1c1.7,0.1,3.4-0.6,4.6-1.8l54.5-52.7c4-3.9,10.5-3.8,14.4,0.2 c3.9,4,3.8,10.5-0.2,14.4l-54.5,52.7C1846.9,1107.1,1840.3,1109.8,1833.3,1109.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AFB5E6",
    d: "M1833.3,1350.8c-0.3,0-0.5,0-0.8,0c-7.2-0.2-14-3.3-18.9-8.6l-16.7-18.1c-3.8-4.1-3.6-10.6,0.6-14.4 c4.1-3.8,10.6-3.5,14.4,0.6l16.7,18.1c1.2,1.3,2.8,2,4.5,2.1c1.8,0.1,3.4-0.6,4.6-1.8l54.5-52.7c4-3.9,10.5-3.8,14.4,0.2 c3.9,4,3.8,10.5-0.2,14.4l-54.5,52.7C1846.9,1348.1,1840.3,1350.8,1833.3,1350.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1674.9966,
    y1: 2279.8254,
    x2: 1522.3367,
    y2: 2395.1687,
    gradientTransform: "matrix(1 0 0 1 -435.4707 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#554482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#2E3459"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M1165.2,2269.1c14.8,10.3,83.4,63.4,93.4,71.9c10,8.5,21.3,36.2,18.3,44.7c-13.9,0-121.7,0-131,0 c-9.2,0-21.6-13.9-21.6-13.9v10.8h-46.2c-15.4-30.8-10.6-95.2-0.5-113.5C1087.6,2250.9,1165.2,2269.1,1165.2,2269.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1229.1135,
    y1: 2256.3425,
    x2: 1358.0244,
    y2: 2381.8608,
    gradientTransform: "matrix(1 0 0 1 -435.4707 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#554482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#2E3459"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M934.7,2268.2c6.5,17.4,12.8,82.8,0,104.4c-7.4,3.9-20.5,6.9-20.5,6.9l-6.9-10.8 c0,0-10,16.2-23.1,16.9c-13.1,0.8-86.3,10-100.2-9.2c-0.8-16.2,12.7-39.9,25.2-53.1c12.5-13.2,21-44,21-66.3 c0-22.3,51.6-42.4,67.8-28.5C914.2,2242.4,934.7,2268.2,934.7,2268.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M1170.8,1914.2c-1.5,33.9,0,309.7,0,350.6c-11.4,12.1-51.1,20.3-84.6,15.6c-7.1-1-14-2.6-20.2-4.9 c-12.3-47-27.6-298.2-21.5-322.8c-3.1-17-56.4-332-56.4-332s-34.6,250-43.9,327.4c10.8,60.4-10,278.8-5.4,316.7 c-14.6,15.2-59.4,18.5-90.5,12.4c-13.2-2.6-23.9-6.8-28.9-12.4c-7.7-31.5-6.2-310.5-9.2-373.7c-3.1-63.2-20.5-350.1-12.1-451.9 c0,0,0.9-3.2,2.9-8.7c11.7-32.3,60.8-144.3,176.6-146.4c135.4-2.4,169.9,133,176.7,167C1161.1,1485.1,1172.3,1880.3,1170.8,1914.2 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M1086.2,2280.4c-7.1-1-14-2.6-20.2-4.9c-12.3-47-27.6-298.2-21.5-322.8c-3.1-17-56.4-332-56.4-332 s28.3,41.3,41.8,86.5c13.6,45.2,35.4,181.4,38.3,233.5C1070.6,1983.6,1082.2,2204.3,1086.2,2280.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M985.9,1308c0,0-10.3,163.5,7.8,184.7c18.1,21.1,132.4,13.9,164-14.1c0,0-91.7-168.3-117.1-175 C1015.3,1296.7,985.9,1308,985.9,1308z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M952.4,1482.2c-19.2,31.7-76,16.5-106.3,38.4c-29.3,21.2-3.6,341.2-2.1,410.5 c1.2,54.8,3.4,261.8,4.3,346.1c-13.2-2.6-23.9-6.8-28.9-12.4c-7.7-31.5-6.2-310.5-9.2-373.7c-3.1-63.2-20.5-350.1-12.1-451.9 c0,0,0.9-3.2,2.9-8.7C864.7,1438.2,952.4,1482.2,952.4,1482.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M911.3,826.2l139.9-3.9c0,0-28.1,497.3-31.4,497.3c-15.8,0-69.1,5-90.5-7L911.3,826.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M899.3,867.6c0,0,43,27.1,78.4,26c35.4-1.1,80.6-34.5,80.6-34.5l-7-36.8l-139.9,3.9L899.3,867.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF647B",
    d: "M968.9,837.6c-1.1,2.3-22,51.4-22,51.4l16.4,33.4L944,1059.3v168.5c0,0,24.3,40.1,33.6,40.7 c9.4,0.6,33.1-48.1,33.1-48.1v-194.5l-12.5-104.6l10.1-34.8l-27-48.9H968.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 2676.1941,
    y1: 959.4265,
    x2: 2963.0898,
    y2: 1475.8391,
    gradientTransform: "matrix(-1 0 0 1 3948.0156 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#554482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#2E3459"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M1192.7,903.7c28.3,51.5,55.8,208.3,70.9,223.4c15.1,15.1,100.8,72,136,92.6c0,0,8.7,41-15.3,68.6 c-3.3,3.8-7.1,7.3-11.7,10.5c-48.4-9.8-153.7-64.6-177.4-87c-8.1-7.7-44.4-54.3-69.3-113c-6.6,32.8,48,321,46.9,369.7 c-42.9,38.4-150.9,21.7-170.1,13.8c-11.1-95.5,1.7-269.4,0.1-353.9c0-1.6-0.1-3.1-0.1-4.5c-4.1-157.2,38.5-236.4,48.4-301.4 c4.9,3.1,12.4,7.5,21.5,12.3c0,0,0,0,0,0C1100,848.8,1177.9,876.7,1192.7,903.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 3194.0298,
    y1: 901.2985,
    x2: 2982.6416,
    y2: 1484.4979,
    gradientTransform: "matrix(-1 0 0 1 3948.0156 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#554482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#2E3459"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M755.7,891.8c31.7-27.1,90.7-49.8,155.5-65.6c19.6,34.4,45.3,140.3,41.2,297.5c0,1.5-0.1,3-0.1,4.5 c-1.6,84.5,11.2,258.4,0.1,353.9c-19.2,7.9-138.4,18.5-181.4-19.9c-1.7-113.6,59.4-324.5,18.7-403.1c0,0-55.4-65.6-52-93.9 S755.7,891.8,755.7,891.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#634E96",
    d: "M1084.4,940.5c-11.5,13-28,31.7-18.3,59.9c20.9,61.1-54.1,100.7-63.2,127.8c0-1.6-0.1-3.1-0.1-4.5 c-4.1-157.2,38.5-236.4,48.4-301.4c4.9,3.1,12.4,7.5,21.5,12.3c0,0,0,0,0,0s20,51.6,23.4,65.2S1095.9,927.5,1084.4,940.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#634E96",
    d: "M952.4,1123.7c0,1.5-0.1,3-0.1,4.5c-11.5-30.5-74.5-28.3-72.2-156.6c0.3-16.5,1.1-25.4-24.3-36.2 c-25.4-10.8,6.3-68.5,22.6-99.8v0c12.5-3.8,26.9-5.6,32.8-9.4C930.9,860.7,956.6,966.5,952.4,1123.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D87",
    d: "M911.3,826.2c71,33.9,101.1,19.9,139.9,0c-9.2-30.4-16.1-74.6-16.1-74.6c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.9-0.7-3.5-2.7-7.4-5.8h0c-27.1-21-116.2-89.2-113.2-76.7c3.4,14.8,3,48.8,3,48.8C920.3,737.4,930.3,787.6,911.3,826.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7D71",
    d: "M962.2,748.4c26.9,27.2,69.9,86.9,69.9,86.9l19-9.1c-9.2-30.4-16.1-74.6-16.1-74.6 c-0.1-0.1-0.2-0.2-0.3-0.2c-2.5-2.2-5-4.1-7.4-5.8h0C991.7,721.3,962.2,748.4,962.2,748.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAD98",
    d: "M924.7,612c0,0-46.2,126.1,48,168.6c110.6,49.9,99.8-46.7,93.1-143.6c0,0-22.1-44.1-59.5-42.2 C968.9,596.7,924.7,612,924.7,612z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M897.4,703.2c5.5,12.9,11.2,26.1,15.8,39.8c2.2,6.7,7.4,19.3,11.5,19.2c-2-15.9,2.7-40.6,3.2-55.8 c1-26.9,2.2-55.1,15.1-69.6c24-26.9,104.6,21.1,122.9,0c78.3-90.6-27-84.3-71-91.2c-29.9-4.7-79.6,0.9-107.5,53.7 C869.2,633.9,882.3,667.4,897.4,703.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D87",
    d: "M897.4,703.3c2.9,14.5,9.7,22.5,15.8,26.9c6,4.4,11.3,5.2,11.3,5.2s0,0,0,0c6.1-5.8,10.3-26,3.3-41.8 c0,0,0,0,0,0c-6.8-8.8-26.1-15.9-30.4-3.3C896.4,693.5,896.2,697.7,897.4,703.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F4C91",
    d: "M1258.6,2341c-5.4-4.4-35.5-14.7-67.8-7.1c-32.2-16.1-61.1-41.6-61.1-41.6s18.7-9.4,52.6-10.6L1258.6,2341 z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F4C91",
    d: "M795.9,2341c6.6-9.6,59.1-15.8,83.7,0c13.6-23.2,21.7-30.7,24.6-46.9c-9.3-7.6-55.8-16.9-78.2-6.2 L795.9,2341z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M722.5,1151.1c15-42.2,63-113.7,73.4-119.1c15.3,22.6,22.8,110.9,0,208.7c-4.1-6.9,24.7-137.5-6.2-181.6 C789.7,1059.2,737.5,1127.7,722.5,1151.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M1151.8,1306.3c-21.4-43.6-47.4-186.4-28.2-234.9c20.4,35.2,49.1,113.2,129.1,177.1 c-62.4-26.6-105.2-100.1-126.8-149.8C1126,1098.8,1130,1158,1151.8,1306.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8A3EFF",
    d: "M1593,1171.8c4.8,13.9-8.1,18.3-3.3,32.1c4.8,13.9,17.6,9.5,22.4,23.3l-942.2,323.7 c0,0-65-39.6-38.1-110.9l942.2-323.7c4.8,13.9-8.1,18.3-3.3,32.1C1575.4,1162.3,1588.3,1157.9,1593,1171.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.3,
    y: 1363.8,
    transform: "matrix(0.9457 -0.325 0.325 0.9457 -387.243 439.6383)",
    fill: "#E6E6E6",
    width: 1024.6,
    height: 30.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.2,
    y: 1282,
    transform: "matrix(0.9457 -0.325 0.325 0.9457 -362.1789 426.0564)",
    fill: "#F2F2F2",
    width: 1024.6,
    height: 30.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#634E96",
    d: "M669.9,1550.9l-33.1,11.4c0,0-65-39.6-38.1-110.9l33.1-11.4C604.8,1511.3,669.9,1550.9,669.9,1550.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7D71",
    d: "M1752.6,1127.2l-32.1,22.9l-108.4,77.2c-4.8-13.9-17.6-9.4-22.4-23.3c-4.8-13.9,8.1-18.3,3.3-32.1 c-4.8-13.9-17.6-9.4-22.3-23.3c-4.8-13.9,8.1-18.3,3.3-32.1l132.9-5.7l39.4-1.7C1764.9,1108.1,1767.7,1116.3,1752.6,1127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292F52",
    d: "M1752.6,1127.2l-32.1,22.9c-6.2-4.6-10.9-10.4-13.3-17.5c-2.4-7-2.4-14.5-0.3-21.9l39.4-1.7 C1764.9,1108.1,1767.7,1116.3,1752.6,1127.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D87",
    d: "M722.5,1471.9c11.9,11,7.6,51.7,39,65.3s78-26.3,76.3-39s-14.4-16.1-14.4-16.1s18.7-9.3,1.7-14.4 c-17-5.1-41.5-11-44.9-16.1c-3.4-5.1-23.8-20.4-33.9-11.9C736.1,1448.2,722.5,1471.9,722.5,1471.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M786.1,1443.1l5.7,14.6c0,0-22.1,35-63.1,25.5l-6.1-11.2L786.1,1443.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 3295.3018,
    y1: 926.0641,
    x2: 3108.8533,
    y2: 1440.4575,
    gradientTransform: "matrix(-1 0 0 1 3948.0156 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#554482"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#2E3459"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M755.7,891.8c-18.8,18-111.9,152.7-145.9,236.3c-11.8,29.1-7.9,61.1,0,90.5 c7.9,29.4,90.5,238.6,109.7,256.7c29.4,3.4,61.1-12.4,71.2-31.7c-9-28.3-80.2-218.8-93.7-241.4c14.6-44.2,70.7-119.2,92.6-143 C827,1018.5,804.4,845.4,755.7,891.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D87",
    d: "M1385.7,1306.6c23.7,20.2,38.3,31.8,69.9,14c44.2-24.9,17-64.7,0-70.3c-17-5.7-36.2,16.8-45.2,33.8 C1401.3,1301.2,1385.7,1306.6,1385.7,1306.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.c73c3c1281547d8e56d1a55dd92a682b.svg";
export { ForwardRef as ReactComponent };